import { render, staticRenderFns } from "./NewTextContribution.vue?vue&type=template&id=947a8c2a&scoped=true"
import script from "./NewTextContribution.vue?vue&type=script&lang=js"
export * from "./NewTextContribution.vue?vue&type=script&lang=js"
import style0 from "./NewTextContribution.vue?vue&type=style&index=0&id=947a8c2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947a8c2a",
  null
  
)

export default component.exports